import { render, staticRenderFns } from "./AddAttachments.vue?vue&type=template&id=40a119a4&scoped=true"
import script from "./AddAttachments.vue?vue&type=script&lang=js"
export * from "./AddAttachments.vue?vue&type=script&lang=js"
import style0 from "./AddAttachments.vue?vue&type=style&index=0&id=40a119a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a119a4",
  null
  
)

export default component.exports